import moment from 'moment-timezone';

class CalendarItem {

    dateMoment: moment.Moment;
    dateFriendly: string;
    isValidDate: boolean;
    lowestPrice: any = null;
    isPast: boolean = false;
    isThisPage: boolean = false;
    offSale: any = false;
    linkedOccurrence: any = false;
    showWaitList: boolean = false;
    toggleLinkedOccurrence: boolean = false;
    toggleWaitListWidget: boolean = false;

    constructor(dateMoment: moment.Moment, dateFriendly: string, isValidDate: boolean) {
        this.dateMoment = dateMoment;
        this.dateFriendly = dateFriendly;
        this.isValidDate = isValidDate;
    }
}

export default CalendarItem;